import * as API from "../../api"
import * as ActionTypes from "../action-types";
import { REDUX } from '../../../constants'
// import { TIME } from "../../util";

/**
 * ThirdParty Library
 */
 import {
    message
} from 'antd'

// Redux Action
import {
    add_vehicle_group_by_vid_success
} from './vehicleGroups'
// import {
//     get_vehicle_event_log_by_timeframe_request
// } from './vehicleLogs'
// import {
//     get_vam_reminders_thru_vid_request
// } from './vamReminders'
// import {
//     get_batch_coordinate_address_success
// } from './locationTracking'

// Services
import { subscribeWS } from '../../websocket'

import {
    setLoadingVehicle,
    unsetLoadingVehicle
} from './style'

/**
 * Get Vehicle
 */

export const get_vehicle_request = (vid, uid) => dispatch => {

    // dispatch(get_vam_reminders_thru_vid_request(vid))

    API
    .getVehicleInfoByVID(vid)
    .then(info => {
        
        try {
            const {
                vehicleProfile,
                vehicleStatics,
                vehicleState,
                vehicleDerivativeState,
                vehicleGeoState,
                vehicleFuelProfile,
                vehiclePackageProfile
            } = info

            dispatch(get_vehicle_success(vehicleStatics,vehicleState, vehicleProfile,  vehicleDerivativeState, vehicleGeoState, vehicleFuelProfile, vehiclePackageProfile))

            // subscribeWS(
            //     [vid],
            //     uid
            // )

            subscribeWS({
                ids: [vid],
                uid: uid
            })

        } catch(err) {
            message.error('Error in getting vehicles. Refresh page?')
        }

    })
}

const get_vehicle_success = (vehicleStatics,vehicleState, vehicleProfile,  vehicleDerivativeState, vehicleGeoState, vehicleFuelProfile, vehiclePackageProfile) => {
    return {
        type: ActionTypes.GET_VEHICLE,
        vehicleStatics,
        vehicleState,
        vehicleProfile,  
        vehicleDerivativeState,
        vehicleGeoState,
        vehicleFuelProfile, 
        vehiclePackageProfile
    };
}

/**
 * Get Vehicles
 */

 export const get_vehicles_request = (vids, uid) => dispatch => {

    let vidBatch = []

    
    vids.map((vid, index) => {
        
        if(!vidBatch.includes(vid)) {
            vidBatch.push(vid)
        }

        if( 
            (index+1) % REDUX.REDUX_VEHICLE_BATCH_GET_SIZE === 0
            ||
            index+1 === vids.length
        ) {
            dispatch(batch_get_vehicles_request(vidBatch, uid))
            vidBatch = []
        }

        return null
    })
 }

export const get_vehicle_state_by_plate_request = (plate, trackid, cb = () => {}) => dispatch => {
    API
    .getVehicleStateByPlate(plate)
    .then(info => {
        
        try {
            const {
                vehicleState,
                odometer
            } = info

            dispatch(get_vehicle_state_by_plate_success({odometer, ...vehicleState}))
            cb(vehicleState)

            trackid
            &&
            subscribeWS({
                trackid
            })
        }
        catch(err) {
            message.error('Error in getting vehicle info. Refresh page?')
        }
    })
}

export const get_vehicle_by_plate_request = (plate, cb = () => {}) => dispatch => {

    API
    .getVehicleByPlate(plate)
    .then(info => {
        
        // try {
            const {
                vehicle,
                status
            } = info

            if(status === 200) {
                dispatch(get_vehicle_static_by_plate_success(vehicle))
                cb(vehicle)
            } else {
                message.error('Error in getting vehicle info. Refresh page?')
                // message.error('')
            }

        // }
        // catch(err) {
        // }
    })
}

const get_vehicle_state_by_plate_success = (vehicleState) => {
    return {
        type: ActionTypes.GET_VEHICLE_STATE_THRU_PLATE,
        vehicleState
    }
}

const get_vehicle_static_by_plate_success = (vehicleStatics) => {
    return {
        type: ActionTypes.GET_VEHICLE_STATIC_THRU_PLATE,
        vehicleStatics
    }
}

/**
 * Batch Get Vehicle
 */
 export const batch_get_vehicles_request = (vids, uid) => dispatch => {

    // vids
    // &&
    // vids.map(vid => dispatch(get_vam_reminders_thru_vid_request(vid)))

    // vids && vids.length && vids.map(vid => 
    //     dispatch(get_vehicle_event_log_by_timeframe_request(
    //         vid,
    //         TIME.parseStartOfDate(),
    //         TIME.getCurTime(),
    //     ))
    // )

    API
    .getVehicleInfoBatch(vids)
    .then(info => {
        
        try {
            const {
                vehicleProfiles,
                vehicleStatics,
                vehicleStates,
                vehicleDerivativeStates,
                vehicleGeoStates,
                vehicleFuelProfiles,
                vehiclePackageProfiles,
                vehicleRuleTemplates,
                vehicleMDVRStates
            } = info

            dispatch(batch_get_vehicles_success(vehicleStatics,vehicleStates, vehicleProfiles,  vehicleDerivativeStates, vehicleGeoStates, vehicleFuelProfiles, vehiclePackageProfiles, vehicleRuleTemplates, vehicleMDVRStates))

            subscribeWS({
                ids: vids,
                uid: uid
            })


        } catch(err) {
            message.error('Error in batch getting vehicles. Refresh page?')
        }

    })
    .finally(() => {

        // vids && vids.length && vids.map(vid => 
        //     setTimeout(() => 
        //         dispatch(get_vehicle_event_log_by_timeframe_request(
        //             vid,
        //             TIME.parseStartOfDate(),
        //             TIME.getCurTime(),
        //         ))
        //     , 100)
        // )
    })
}

const batch_get_vehicles_success = (vehicleStatics,vehicleStates, vehicleProfiles,  vehicleDerivativeStates, vehicleGeoStates, vehicleFuelProfiles, vehiclePackageProfiles, vehicleRuleTemplates, vehicleMDVRStates) => {
    return {
        type: ActionTypes.GET_VEHICLES,
        vehicleStatics,
        vehicleStates,
        vehicleProfiles,  
        vehicleDerivativeStates,
        vehicleGeoStates,
        vehicleFuelProfiles, 
        vehiclePackageProfiles,
        vehicleRuleTemplates,
        vehicleMDVRStates
    };
}

/**
 * Set Selected Vehicle
 */
export const set_selected_vehicle_request = (vid) => dispatch =>  {
    dispatch(set_selected_vehicle_success(vid))
}

const set_selected_vehicle_success = (vid) => {
    return {
        type: ActionTypes.SET_SELECTED_VEHICLE,
        vid
    }
}

/**
 * Clear Selected Vehicle
 */
export const clear_selected_vehicle_request = () => dispatch => {
    dispatch(clear_selected_vehicle_success())
}

const clear_selected_vehicle_success = () => {
    return {
        type: ActionTypes.CLEAR_SELECTED_VEHICLE
    }
}

// Update Vehicle thru Websocket

export const update_vehicle_info_thru_ws_request = (vid, vehicle) => dispatch => {
    dispatch(update_vehicle_info_thru_ws_success(vid, vehicle))
}

const update_vehicle_info_thru_ws_success = (vid, vehicle) => {
    return {
        type: ActionTypes.UPDATE_VEHICLE_INFO_THRU_WS,
        vid,
        vehicle
    };
}

export const update_vehicle_geo_state_thru_ws_request = (vid, vehicle) => dispatch => {
    dispatch(update_vehicle_geo_state_thru_ws_success(vid, vehicle))
}

const update_vehicle_geo_state_thru_ws_success = (vid, vehicle) => {
    return {
        type: ActionTypes.UPDATE_VEHICLE_GEO_STATE_THRU_WS,
        vid,
        vehicle
    };
}

export const update_vehicle_state_info = (vid, vehicle) => dispatch => {
    dispatch(update_vehicle_state_info_success(vid, vehicle))
}

const update_vehicle_state_info_success = (vid, vehicle) => {
    return {
        type: ActionTypes.UPDATE_VEHICLE_STATE_INFO,
        vid,
        vehicle
    };
}

export const get_vehicle_address_request = (location, vid) => dispatch => {

    (location.lat && location.lon) 
    &&
    API
    .getVehicleAddressByVID(
        vid,
        location.lat,
        location.lon
    )
    .then(info => {
        const { status, data } = info

        if(status === 200) {
            dispatch(get_vehicle_address_success(data))
        }
    })
}

const get_vehicle_address_success = (data) => {
    return {
        type: ActionTypes.UPDATE_VEHICLE_ADDRESS,
        data
    }
}

export const get_batch_vehicle_address_request = (items) => dispatch => {

    API
    .getVehicleAddressBatchByVIDS(
        items
    )
    .then(info => {

        const { data, status } = info 

        if(status === 200) {
            dispatch(get_batch_vehicle_address_success(data))
            // dispatch(get_batch_coordinate_address_success(data))
        } 
        // else {
        //     message.error('Failed in getting addresses.')
        // }
    })
}

const get_batch_vehicle_address_success = (data) => {
    return {
        type: ActionTypes.UPDATE_VEHICLE_ADDRESSES,
        data
    }
}

export const create_vehicle_request = (items, cb = () => {}) => dispatch => {
    dispatch(setLoadingVehicle())

    API
    .createVehicle(
        items
    )
    .then(info => {
        const { vehicle, status, msg } = info

        if(status === 200) {
            dispatch(create_vehicle_success({ ...vehicle, vpkgids: items.vpkgids, fuelProfile: items.fuelProfile }))
            dispatch(add_vehicle_group_by_vid_success([vehicle.vid], items.vhcgids, items.uid))
            message.success(msg)
            cb()
        } else if(status === 401) {
            message.warning(`Failed in updating vehicle. ${msg}`)
        } else {
            message.warning(`Failed in updating vehicle. Retry?`)
        }

    })
    .finally(() => {
        // cb()
        dispatch(unsetLoadingVehicle())
    })
}

const create_vehicle_success = (vehicle) => {
    return {
        type: ActionTypes.CREATE_VEHICLE,
        vehicle
    }
}

export const update_vehicle_request = (items, cb = () => {}) => dispatch => {

    dispatch(setLoadingVehicle())

    API
    .updateVehicle(
        items
    )
    .then(info => {
        const { vehicle, status, msg } = info

        if(status === 200) {
            dispatch(update_vehicle_success({ 
                ...vehicle, 
                ...items.vehicle, 
                ruletids: items.ruletids, 
                imei: items.imei, 
                vhcgids: items.vhcgids, 
                vpkgids: items.vpkgids,
                fuelProfile: items.fuelProfile 
            })) 
            dispatch(add_vehicle_group_by_vid_success([vehicle.vid], items.vhcgids, items.uid))
            cb()
        } else if(status === 401) {
            message.warning(`Failed in updating vehicle. ${msg}`)
        } else {
            message.warning(`Failed in updating vehicle. Retry?`)
        }

    })
    .finally(() => {
        // cb()
        dispatch(unsetLoadingVehicle())
    })
}

const update_vehicle_success = (vehicle) => {
    return {
        type: ActionTypes.UPDATE_VEHICLE,
        vehicle
    }
}

export const create_vehicles_request = (items) => dispatch => {

    API
    .createVehicles(
        items
    )
    .then(info => {

        const { status, vehicles, msg } = info

        if(status === 200) {
            dispatch(create_vehicles_success(vehicles))
            dispatch(add_vehicle_group_by_vid_success(vehicles.map(v => v.vehicle.vid), vehicles[0]?.vhcgids, items.uid))
        } else if(status === 401) {
            message.warning(`Failed in updating vehicle. ${msg}`)
        } else {
            message.warning(`Failed in updating vehicle. Retry?`)
        }
    })

}

const create_vehicles_success = (vehicles) => {

    return {
        type: ActionTypes.CREATE_VEHICLES,
        vehicles
    }
}